import CustomSkeletonTable from "../../ui/CustomSkeletonTable/CustomSkeletonTable";
import FetchFeedback from "../../ui/CustomFetchFeedback/CustomFetchFeedback";
import TransactionTableTanStack from "./tables/TransactionTableTanStack";
import { TransactionDetailsModal, ReassignTransactionModal } from "./modals";
import TransactionEmptyState from "./TransactionEmptyState";

const TransactionContent = ({
  data: {
    transactions,
    totalElements,
    totalPages,
    noTransactions,
    isLoading,
    isFetching,
    isError,
    onRetry,
    initialLoadDone,
  },
  paginationProps: { pagination, setPagination },
  filters: { searchQuery },
  merchants: { merchantOptions, isMerchantOptionsError },
  modals: { details: detailsModal, reassign: reassignModal },
  isSuperAdmin,
  activeTab,
}) => {
  if (!initialLoadDone && isLoading) {
    return (
      <CustomSkeletonTable
        columns={[1, 2, 3, 4, 5, 6, 7, 8]}
        rowCount={pagination.pageSize}
      />
    );
  }

  if (isError) {
    return (
      <FetchFeedback
        message={"Failed to load transactions. Please try again."}
        onRetry={onRetry}
      />
    );
  }

  if (noTransactions && !isLoading) {
    return <TransactionEmptyState searchQuery={searchQuery} />;
  }

  return (
    <>
      <TransactionTableTanStack
        pagination={pagination}
        data={transactions}
        onPaginationChange={setPagination}
        totalElements={totalElements}
        totalPages={totalPages}
        isLoading={isLoading}
        isFetching={isFetching}
        onRowClick={detailsModal.openModal}
        onReassignClick={reassignModal.openModal}
        isSuperAdmin={isSuperAdmin}
        merchantOptions={merchantOptions}
        isMerchantOptionsError={isMerchantOptionsError}
        activeTab={activeTab}
      />

      <TransactionDetailsModal
        opened={detailsModal.isOpen}
        onClose={detailsModal.closeModal}
        transactionData={detailsModal.transaction ?? {}}
      />
      <ReassignTransactionModal
        opened={reassignModal.isOpen}
        onClose={reassignModal.closeModal}
        transactionData={reassignModal.transaction ?? {}}
        merchantOptions={merchantOptions}
        control={reassignModal.control}
        onSubmit={reassignModal.handleSubmit}
        isSubmitting={reassignModal.isSubmitting}
      />
    </>
  );
};

export default TransactionContent;
